// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as ReactSpring from "react-spring";
import * as Web from "@react-spring/web";

function AnimButton(Props) {
  var s = Props.s;
  var emote = Props.emote;
  var className = Props.className;
  var onClick = Props.onClick;
  var children = Props.children;
  var match = React.useState(function () {
        return false;
      });
  var setHover = match[1];
  var style = ReactSpring.useSpring(Curry._1(s, match[0]));
  return React.createElement("button", {
              className: Belt_Option.getWithDefault(className, ""),
              onClick: onClick,
              onMouseEnter: (function (param) {
                  return Curry._1(setHover, (function (param) {
                                return true;
                              }));
                }),
              onMouseLeave: (function (param) {
                  return Curry._1(setHover, (function (param) {
                                return false;
                              }));
                })
            }, React.createElement(Web.animated.span, {
                  style: style,
                  children: emote
                }), children);
}

var make = AnimButton;

export {
  make ,
  
}
/* react Not a pure module */
